(function () {
  "use strict";

  const ROOT_SELECTOR = "[data-eyes]";
  const VIDEO_SELECTOR = "video.eyes-video";

  function playVideo(video) {
    if (!video) return;
    video.muted = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {});
    }
  }

  function pauseVideo(video) {
    if (!video) return;
    video.pause();
  }

  function getVideos(section) {
    return Array.from(section.querySelectorAll(VIDEO_SELECTOR));
  }

  function unbindObserver(section) {
    if (section.__eyesObserver) {
      section.__eyesObserver.disconnect();
      section.__eyesObserver = null;
    }
  }

  function bindObserver(section) {
    unbindObserver(section);

    var videos = getVideos(section);
    if (videos.length === 0) return;

    if (typeof IntersectionObserver === "undefined") {
      videos.forEach(playVideo);
      return;
    }

    section.__eyesObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            playVideo(entry.target);
          } else {
            pauseVideo(entry.target);
          }
        });
      },
      { root: null, threshold: 0.35 }
    );

    videos.forEach(function (video) {
      section.__eyesObserver.observe(video);
    });
  }

  function initSection(section) {
    if (!section) return;
    bindObserver(section);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initSection(
      event.target.querySelector(ROOT_SELECTOR) || event.target.closest(ROOT_SELECTOR)
    );
  });
})();
